<div *ngIf="loading" class="container">
  <div class="row">
    <div class="col-12 text-center mt-5 mb-5">
      <fa-icon [icon]="['fas', 'spinner']" size="4x" spin="true" class="text-ihm">
      </fa-icon>
      <p class="text-ihm mt-4">Loading Blog</p>
    </div>
  </div>
</div>
<div *ngIf="!loading && blog" class="container second-container">
  <div class="row">
    <div class="col-12 mt-5 mb-md-2">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
          <li class="breadcrumb-item"><a [routerLink]="['/blog']">Blog</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{blog.title}}</li>
        </ol>
      </nav>
    </div>
  </div>
</div>
<div *ngIf="!loading && blog" class="container">
  <div class="row">
    <div class="col-12 text-center mb-5">
      <div *ngIf="blog.main_image" class="card-image-top pt-1" alt="{{blog.title}}">
        <img [src]="blog.main_image" class="img img-responsive mw-100" loading="lazy">
      </div>
    </div>
    <div class="col-12">
      <h5 class="card-title">
        <a [routerLink]="['/blog/post', blog.id]">{{blog.title}}</a>
      </h5>
    </div>

    <div class="col-12 card-tags d-inline-flex">
      <p class="flex">
        {{blog.author_name}}
      </p>
      <p class="flex">
        {{blog.updated_at | date: 'mediumDate'}}
      </p>
      <p class="flex">
        Tags
      </p>
    </div>
    <div class="col-12 mb-5">
      <div class="card-blog-body" [innerHtml]="blog.body | safeHtml">
      </div>
    </div>
  </div>
</div>
<div class="container-fluid sub-container mt-5">
  <div class="row">
    <div class="col-12">
      <app-mailing-list></app-mailing-list>
    </div>
  </div>
</div>
